import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {ItemManagerService} from "../../services/itemManager/item-manager.service";
import {Item} from "../../models/Item";
import {debounceTime} from "rxjs/operators";
import {CookieService} from "../../services/coockieService/coockie.service";
import {UiAdapterService} from "../../services/uiAdapterService/ui-adapter.service";
import {CesiumAdapterService} from "../../services/cesiumAdapter21/cesium-adapter.service";
import {isViewMode, isViewModeByShareLink} from '@src/configs/view_only';

@Component({
  selector: 'app-global-objects-lock',
  templateUrl: './global-objects-lock.component.html',
  styleUrls: ['./global-objects-lock.component.scss']
})
export class GlobalObjectsLockComponent implements OnInit {

  public isGlobalLock = true;
  public Yiit = Yiit;
  private timer = null;
  public isHoverOn = false;

  public isMainDragPopupDisabled = null;

  public dragIconMessage = null;
  public dontShowAgain = false;
  public isMsgBlockOpened = true;
  public objectsCount: number = null;
  public isViewOnly = isViewMode || isViewModeByShareLink;
  private componentsCreated = false;

  constructor(
    private cd: ChangeDetectorRef,
    public im:ItemManagerService,
    private cs: CookieService,
    private viewer: CesiumAdapterService,
    protected uiAdapterService: UiAdapterService
  ) {
    this.isMainDragPopupDisabled = this.cs.checkCookie('isDraggableModalShow');
  }

  ngOnInit() {
    this.dragIconMessage = this.esGetUnescapedString(window['OBJECT_DRAG_ICON_MSG']);

    this.im.itemsList.pipe(debounceTime(500)).subscribe((list)=> {
      this.objectsCount = Object.keys(list).length;
      this.highlightItems()
    });

    this.viewer.isEventsHandlerLoaded.subscribe((_status) => {
      this.componentsCreated = _status;
      this.highlightItems(_status)
      // this.im.isDragTriggeredChanged.subscribe((status)=>{
      //   if (_status){
      //     this.highlightItems(status);
      //   }
      // })
    })
  }

  private esGetUnescapedString(string){
    let div = document.createElement('div');
    div.innerHTML = string;
    return div.innerText;
  }

  private highlightItems(status?){
    // if (!this.isGlobalLockMessageApplied() && status && this.isMsgBlockOpened && this.isMainDragPopupDisabled && this.im.isDragTriggered) {
    if (!this.isGlobalLockMessageApplied() && (status || this.componentsCreated) && this.isMsgBlockOpened && this.isMainDragPopupDisabled && this.objectsCount>0 && document.querySelector('.es-details-inner-wrapper .es-dragged-icon')) {
      document.querySelector('.es-details-inner-wrapper .es-dragged-icon').classList.add('es-global-icon-highlight');
    }
  }

  isGlobalLockMessageApplied():boolean{
    return this.cs.checkCookie('isGlobalLockUnderstand');
  }

  getCurrentIcon(){
    if (this.isGlobalLock){
      if (this.isHoverOn){
        return 'unlock';
      }
      else{
        return 'lock';
      }
    }
    else{
      if (this.isHoverOn){
        return 'lock';
      }
      else{
        return 'unlock';
      }
    }
  }

  setHover(flag){
    this.isHoverOn = flag;
    this.cd.detectChanges();
  }

  closeMsgBlock(dontCheck?) {
    if (!dontCheck) {
      if (this.dontShowAgain) {
        this.cs.setCookie('isGlobalLockUnderstand', true, 21);
      }
    }
    if (document.querySelector('.es-details-inner-wrapper .es-dragged-icon')) {
      document.querySelector('.es-details-inner-wrapper .es-dragged-icon')
        .classList.remove('es-global-icon-highlight');
    }
    this.isMsgBlockOpened = false;
  }

  toggleGlobalLock(){
    if (this.isViewOnly) { return; }
    clearTimeout(this.timer);
    if (this.isGlobalLock){
      // this.timer = setTimeout(()=>{
      //   this.isGlobalLock = true;
      //   this.setItemListDrag(false);
      //   this.timer = null;
      // }, 30000)
    }
    this.isGlobalLock = !this.isGlobalLock;
    this.uiAdapterService.globalDragEnabled = !this.isGlobalLock;
    this.setItemListDrag(!this.isGlobalLock);
  }

  private setItemListDrag(flag){
    this.im.forEach(item => {
      if (!item.config.isCopy){
        item.drag_enabled = flag;
      }
    })
    this.cd.detectChanges();
  }
}
